export enum ChannelType {
  Whatsapp = 2,
  Line,
  Instagram,
  Facebook,
  Twitter,
  CopyLink = 10,
}

export type ShareInfo = {
  shareContentUrl: string;
  shareContentTitle: string;
  shareImageUrl: string;
  shareContentDescription: string;
  sharePageId?: number | string;
  sharePageName?: string;
};
